import { useMainContext } from '@/lib/context';
import { DataLevel, Result, StructureType } from '@/lib/model';
import * as React from 'react';
import { Categories } from './Categories';
import { Coalitions } from './Coalitions';
import './index.scss';
import { Live } from './Live';
import { Party } from './Party';
import { Summary } from './Summary';

export interface ResultsProps {
  selectedResults: Result[];
  onClick: (result: Result) => void;
  is2018: boolean;
  dataLevel: DataLevel;
}

export const Results: React.FC<ResultsProps> = ({ onClick }) => {
  const {
    structureType,
    lastResult,
    selectedResults,
    selectedCandidate,
    setSelectedCandidate,
    innerCandidatesList,
    gradientTable,
    isTurnoutOpen,
    toggleTurnout,
    is2018,
  } = useMainContext();

  const nationalResult = selectedResults[0] as Result;
  const shownResults = [
    nationalResult,
    ...(selectedResults.length > 1 ? selectedResults.slice(-1) : []),
  ];

  const showVoti = !(
    is2018 &&
    selectedResults.length > 1 &&
    selectedResults.slice(-1)[0].level === DataLevel.COLLEGIO
  );

  return (
    <div className="Results">
      <Categories results={shownResults} onClick={onClick} />
      {!is2018 && (
        <Live
          currentNumber={lastResult.scrutinized.current}
          total={lastResult.scrutinized.total}
        />
      )}
      {selectedCandidate ? (
        <Party
          selectedCandidate={selectedCandidate}
          candidates={innerCandidatesList}
          onCandidateClick={setSelectedCandidate}
          gradientTable={gradientTable}
          showVoti={shownResults[0].showVoti}
        />
      ) : (
        <>
          <Coalitions
            data={lastResult.coalitions}
            selectedCandidate={selectedCandidate}
            onCandidateClick={setSelectedCandidate}
            showVoti={showVoti}
          />
          <Summary
            data={lastResult.summary}
            isSignOpen={isTurnoutOpen}
            onSignClick={toggleTurnout}
          />
          <span className="Results__footnote">
            {structureType === StructureType.CAMERA
              ? `*esclusa Valle d'Aosta`
              : `*escluse Valle d'Aosta e Trentino Alto Adige`}
          </span>
        </>
      )}
    </div>
  );
};
